import { Vue, Component } from "vue-property-decorator";
import { getAuthConfig } from "../../utils/auth-helper";
import { EXTERNAL_APP_URI } from "../../common/uri/property-uri.constants";
import { ASSISTANT_EVENTS } from "../../common/assistant.constant";
import { consumePendingArtifact } from "./artifact-store";

@Component({
    name: "AssistantArtifact",
    template: require("./template.html"),
})
export default class AssistantArtifact extends Vue {
    artifactUrl: string = "";
    isLoading: boolean = true;

    private handleMessage: ((event: MessageEvent) => void) | null = null;
    private artifactData: unknown = null;

    mounted() {
        this.artifactData = consumePendingArtifact();
        this.handleMessage = this.onMessage.bind(this);
        window.addEventListener("message", this.handleMessage);
        this.initIframe();
    }

    initIframe() {
        this.isLoading = true;
        const authState = getAuthConfig();

        if (!authState?.oauth2?.accessToken) {
            console.error("[AssistantArtifact] Missing access token");
            this.isLoading = false;
            return;
        }

        const encodedAuthState = encodeURIComponent(JSON.stringify(authState));
        this.artifactUrl = `${EXTERNAL_APP_URI.ASSISTANT_APP}/embed/artifact?auth_state=${encodedAuthState}`;
    }

    onIframeLoad() {
        this.isLoading = false;
    }

    onMessage(event: MessageEvent) {
        const allowedOrigin = new URL(EXTERNAL_APP_URI.ASSISTANT_APP).origin;
        if (event.origin !== allowedOrigin) return;

        const iframe = this.$refs.artifactIframe as HTMLIFrameElement | undefined;
        if (!iframe || event.source !== iframe.contentWindow) return;

        const { data } = event;
        if (!data || typeof data !== "object" || !data.type) return;

        if (data.type === ASSISTANT_EVENTS.EMBED_READY) {
            this.sendArtifactData();
        }
    }

    sendArtifactData() {
        const iframe = this.$refs.artifactIframe as HTMLIFrameElement;
        if (!iframe?.contentWindow || !this.artifactData) return;

        const targetOrigin = EXTERNAL_APP_URI.ASSISTANT_APP;
        iframe.contentWindow.postMessage(
            {
                type: "ARTIFACT_DATA",
                payload: { artifact: this.artifactData },
            },
            targetOrigin
        );
    }

    beforeDestroy() {
        if (this.handleMessage) {
            window.removeEventListener("message", this.handleMessage);
        }
    }
}
